import React, { useState } from 'react'

import { Document, Page } from 'react-pdf/dist/esm/entry.webpack'

const PrivacyPolicies: React.FC = () => {
  const [numPages, setNumPages] = useState<number | null>(null)

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
        padding: '20px',
        minHeight: '100vh'
      }}
    >
      <Document
        file="/privacy-policies.pdf"
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        loading={<div>Carregando documento...</div>}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <div
            key={`page_${index + 1}`}
            style={{
              marginBottom: '20px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}
          >
            <Page
              pageNumber={index + 1}
              renderAnnotationLayer={false}
              renderTextLayer={false} // Se quiser que pareça uma "imagem" pura, deixe false
              width={Math.min(window.innerWidth * 0.9, 900)} // Ajusta ao tamanho da tela
            />
          </div>
        ))}
      </Document>
    </div>
  )
}

export default PrivacyPolicies
